import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class InventoriesService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/GeneralInformation/';

  addinventories(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'InsertInventories', data)
  }

  getinventories(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetInventories?id='+ id)
  }


  getinventoriesLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetInventoriesLY?id=' + id)
  }
}
